<section class="access-denied">
  <h1 class="access-denied__title">Access denied</h1>
  <p class="access-denied__message">
    You do not have access to this project.
  </p>
  <p class="access-denied__message">
    If you believe this is wrong, contact a project administrator.
  </p>
</section>

